import { AxiosError } from 'axios';
import { GET_JOB_STATUS_REPORT_NAME_URL } from '../../constants/apiUrls';
import { GET_JOB_STATUS_REPORT_NAME_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface JobNameResponse {
  displayName: string;
  description: string;
  uuid: string;
}

interface Input {
  onSuccess?: (res: JobNameResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetJobStatusReportName = ({ onError, onSuccess }: Input) => {
  const getJobStatusReportName = async () => {
    const res = await axiosClient.get<JobNameResponse[]>(GET_JOB_STATUS_REPORT_NAME_URL);

    return res.data;
  };

  return useCustomQuery([GET_JOB_STATUS_REPORT_NAME_KEY], getJobStatusReportName, {
    onSuccess,
    onError,
  });
};
